import React from 'react';
import Layout from '../pages/Layout/Layout';
import FeatureUnavailable from '../components/activation/FeatureUnavailable';
import { useEntitlements } from '../hooks/useEntitlements';
import { useNavV6 } from './useNavV6';

/**
 * Route gate that exists ONLY with the new navigation on: the page opens when `open(ctx)` (the same predicate the
 * sidebar/hub tab uses, see navModel), otherwise the calm «not in your package» card. Switch off: the children
 * render exactly as before, no gate.
 */
export default function NavV6Gate({ open, children }) {
  const on = useNavV6();
  const { ready, has, features } = useEntitlements();
  if (!on || !ready) return children;
  if (!open({ has, features })) return <Layout padding={false}><FeatureUnavailable /></Layout>;
  return children;
}
